"use client";

import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-2">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted/20 rounded-md animate-pulse" />)}
      </div>;
  }
  return <nav className="space-y-2">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default block">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  return <footer data-section-id="264733" id="footer" className="bg-background text-foreground border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {}
          <div className="space-y-4 pb-12 lg:pb-0">
            <div className="space-y-2">
              <p className="text-muted-foreground text-sm leading-relaxed font-default">
                Apex IT Solutions AU
              </p>
              <p className="text-muted-foreground text-sm leading-relaxed font-default">
                23 Collins St, Ceduna SA 5690
              </p>
            </div>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="font-default font-semibold text-foreground mb-4 tracking-tight">Get In Touch</h3>
            <div className="space-y-3 text-sm text-muted-foreground font-default">
              <div className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <Link to="tel:0468039299" className="hover:text-primary transition-colors">
                  0468 039 299
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <Link to="mailto:info@apexitsolutionsau.com" className="hover:text-primary transition-colors">
                  info@apexitsolutionsau.com
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <span>Serving Ceduna and Metropolitan Australia</span>
              </div>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-4 tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="46" className="space-y-0">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-muted-foreground text-sm text-center md:text-left font-default">
            © {new Date().getFullYear()} Apex IT Solutions AU. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-muted-foreground text-sm font-default">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms
            </Link>
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="hover:text-primary transition-colors flex items-center gap-1 cursor-pointer">
              Back to Top
            </button>
          </div>
        </div>
      </div>
    </footer>;
}